
require.register("graphlib/lib/version.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "graphlib");
  (function() {
    module.exports = '2.1.7';
  })();
});